import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HubRouterHelperService {
  readonly previousUrl = signal<string | null>(null);
  readonly currentUrl = signal<string | null>(null);

  private readonly router = inject(Router);

  constructor() {
    this.currentUrl.set(this.router.url);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url !== '/404' && event.urlAfterRedirects === '/404') {
          this.previousUrl.set(event.url);
          this.currentUrl.set(event.urlAfterRedirects);
        } else {
          this.previousUrl.set(this.currentUrl());
          this.currentUrl.set(event.url);
        }
      });
  }
}
